/* eslint-disable @typescript-eslint/no-explicit-any */
import { Directive, TemplateRef, inject } from '@angular/core';

@Directive({ selector: '[appRowItemLabelDef]' })
export class RowItemLabelDefDirective {
  templateRef = inject<TemplateRef<any>>(TemplateRef);
}

@Directive({ selector: '[appRowItemContentDef]' })
export class RowItemContentDefDirective {
  templateRef = inject<TemplateRef<any>>(TemplateRef);
}
